module.exports = __webpack_public_path__ + "img/Il_Sole_24.b9e1f758.png";